export default "__VITE_ASSET__BeSelq5j__"